import { render } from "./ModuleActivityButton.vue?vue&type=template&id=405a57e6&scoped=true"
import script from "./ModuleActivityButton.vue?vue&type=script&lang=js"
export * from "./ModuleActivityButton.vue?vue&type=script&lang=js"

import "./ModuleActivityButton.vue?vue&type=style&index=0&id=405a57e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-405a57e6"]])

export default __exports__